import { useRef, createRef } from "react";
import ReactDom from "react-dom";
import ClickAwayListener from "react-click-away-listener";
import { CCPDisbatch, CCPValue } from "../contexts/ccp";
import { useEffect, useState, memo, useContext } from "react";

const useRightClick = (item, onPaste) => {
  const [open, setOpen] = useState(false);
  const ccpDisbatch = useContext(CCPDisbatch);
  const ccpValue = useContext(CCPValue);

  const onContext = (e) => {
    e.preventDefault();
    if (e.stopPropagation) e.stopPropagation();
    const { pageX, pageY } = e;
    setOpen({ pageX, pageY });
  };

  const handleCopy = (e) => {
    e.stopPropagation();
    ccpDisbatch({ type: "copy", item: item });
    setOpen(false);
  };

  const handlePaste = (e) => {
    e.stopPropagation();
    onPaste(ccpValue, { isOver: () => true });
    setOpen(false);
  };

  return [
    <MemMenu
      copyValue={ccpValue}
      handleCopy={handleCopy}
      handlePaste={handlePaste}
      open={open}
      onHide={() => setOpen(false)}
    />,
    onContext,
    open,
  ];
};

const Menu = ({
  open,
  copyValue,
  onHide,
  handleCopy,
  handlePaste,
  handleCut,
}) => {
  if (!open) {
    return <></>;
  }
  return ReactDom.createPortal(
    <ClickAwayListener onClickAway={onHide} mouseEvent={"mousedown"}>
      <div
        style={{
          position: "fixed",
          width: 120,
          backgroundColor: "white",
          border: "1px solid var(--main-border-color)",
          borderRadius: 5,
          boxShadow: "0px 2px 8px 4px rgba(0,0,0,.3)",
          zIndex: 2000,
          left: open.pageX,
          top: open.pageY,
        }}
      >
        <div onClick={handleCopy} className="contextItem">
          Copy
        </div>
        <div onClick={handleCut} className="contextItem">
          Cut
        </div>
        <div
          disabled={!copyValue}
          onClick={handlePaste}
          className="contextItem"
        >
          Paste
        </div>
      </div>
    </ClickAwayListener>,
    document.getElementById("menus")
  );
};

const MemMenu = memo(Menu);

export default useRightClick;
